

import React from 'react';
import {useTranslation} from "react-i18next";
import Section from "../basic/layouts/section";
import CardPortfolio from "../card/card_portfolio";
import PortfolioApi from "../api/portfolio_api";
import {Link} from "react-router-dom";

function SectionPortfolio(props) {

    const { t, i18n } = useTranslation()

    return (<div>

        <Section title={''} name={''} child={<div className={'rounded-5'}>

            <div className="container-fluid">

                <div className="">
                    <div id={'whtat-todo__title-position'} className="pb-5">
                        <small className="text-secondary">
                            {/*{t('subTitle.portfolio')}*/}
                            {t('nav.portfolio')}
                        </small>

                        <h2 className={'display-1'}>
                            {/*{t('nav.portfolio')}*/}
                            Selected Work
                        </h2>

                        <Link to="/projects" className={'text-decoration-none text-white bg-dark rounded-pill p-3 pt-2 pb-2 btn'}>
                            <text>
                                {/*{t('subTitle.more-project')} */}
                                View all
                            </text>
                            {/*<small className={''}>{t('subTitle.more-project')}</small>*/}
                            {/*<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"*/}
                            {/*     className="bi bi-arrow-up-right-square-fill m-1" viewBox="0 0 16 16">*/}
                            {/*    <path*/}
                            {/*        d="M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zM5.904 10.803 10 6.707v2.768a.5.5 0 0 0 1 0V5.5a.5.5 0 0 0-.5-.5H6.525a.5.5 0 1 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 .707.707"/>*/}
                            {/*</svg>*/}
                        </Link>
                    </div>
                </div>

                <div className="d-flex flex-wrap align-items-center">

                    {/*<PortfolioApi optionService={''} w={'col-md-6'}/>*/}

                </div>

            </div>

        </div>} link={'/'} linkName={''}/>

        <div className="text-end p-5">
            <Link to="/projects" className={'text-decoration-none text-dark'}>
                <b>{t('subTitle.more-project')}</b>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                     className="bi bi-arrow-up-right-square-fill m-1" viewBox="0 0 16 16">
                    <path
                        d="M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zM5.904 10.803 10 6.707v2.768a.5.5 0 0 0 1 0V5.5a.5.5 0 0 0-.5-.5H6.525a.5.5 0 1 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 .707.707"/>
                </svg>
            </Link>
        </div>

    </div>);
}

export default SectionPortfolio;
